export enum Currency {
  Pln = 'pln',
  Usd = 'usd',
}
